import { useAuth } from "@/auth/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Stethoscope } from "lucide-react";
import { APP_NAME } from "@/brand";

const ROLE_LABEL = {
  super_admin: "Super-admin",
  clinic_admin: "Admin de clínica",
  therapist: "Terapeuta",
};

export const AppHeader = ({ children }) => {
  const { user, logout } = useAuth();
  return (
    <header className="flex items-center justify-between py-4 gap-3 flex-wrap">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-brand-teal flex items-center justify-center text-white">
          <Stethoscope className="w-5 h-5" />
        </div>
        <div>
          <p className="font-semibold text-brand-navy leading-tight" data-testid="header-user-name">{user.name}</p>
          <p className="text-xs text-slate-500 leading-tight">
            <span className="text-brand-teal font-medium">{ROLE_LABEL[user.role]}</span>
            {user.clinic_name ? ` · ${user.clinic_name}` : ` · ${APP_NAME}`}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        {children}
        <Button variant="ghost" data-testid="logout-button" onClick={logout} className="rounded-full text-slate-500 hover:text-brand-navy">
          <LogOut className="w-4 h-4" /> Salir
        </Button>
      </div>
    </header>
  );
};
